import { NgModule } from '@angular/core';

import { WkCoreExtensionService } from '../services/wk-core-extensions.service';
import * as officeEditingRules from './rules/microsoft-online-editing.rules';
import { WkAuthenticationService } from '../services';
import { MsOnlineEditingStoreModule } from './store/microsoft-online-editing-store.module';

@NgModule({
  imports: [MsOnlineEditingStoreModule],
})
export class MsalModule {
  constructor(
    extensions: WkCoreExtensionService,
    authenticationService: WkAuthenticationService
  ) {
    extensions.setEvaluators({
      canToggleEditOffline: officeEditingRules.updateToggleEditOffline,
      'app.options.canEditOnlineWordFile':
        officeEditingRules.canEditOnlineWordFile,
      'app.options.canEditOnlinePowerPointFile':
        officeEditingRules.canEditOnlinePowerPointFile,
      'app.options.canEditOnlineExcelFile':
        officeEditingRules.canEditOnlineExcelFile,
      'app.options.canEndMicrosoftOnlineSession':
        officeEditingRules.canUpdateMicrosoftSession,
      'app.options.canResumeOnlineWordFile':
        officeEditingRules.canResumeOnlineWordFile,
      'app.options.canResumeOnlinePowerPointFile':
        officeEditingRules.canResumeOnlinePowerPointFile,
      'app.options.canResumeOnlineExcelFile':
        officeEditingRules.canResumeOnlineExcelFile,
      'app.options.isSSOLoggedIn': () => authenticationService.isSsoLoggedIn(),
    });
  }
}
